import { useEffect, useRef, type ReactNode } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  captureRegistrationClick,
  captureRegistrationView,
} from './registrationEvents'

export function EmailLeadRedirect({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const leadEmail = searchParams.get('email')?.trim()
  // StrictMode would double-count the funnel events.
  const skipped = useRef(false)

  useEffect(() => {
    if (!leadEmail || skipped.current) return
    skipped.current = true
    captureRegistrationView(searchParams, { prefilled: true })
    captureRegistrationClick({ signupMethod: 'password', prefilled: true })
    navigate(
      { pathname: '/signup/create', search: searchParams.toString() },
      { replace: true },
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (leadEmail) return null
  return <>{children}</>
}
